import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation, Trans } from 'react-i18next';

/**
* Calculates how much user is going to pay
* 
* @param {Object} props
* @param {Object} props.plan     - Selected plan
* @param {string} props.points   - Total users points
* @param {Object} props.period   - Payments period
* @param {Object} props.product  - Current product
* @param {Object} props.discount - Discount granted by coupon
* @param {string} props.coupon   - Users coupon
*/
const CostCalculator = ({ plan, points, period, product, discount, coupon }) => {
  const { t, i18n } = useTranslation('costCalculator');
  const periodValue = (period?.value || -1);
  const planValue = (plan?.value || -1);
  const pointsTotal = (product ? 1 : points)
  const price = planValue * periodValue * parseInt(pointsTotal);
  const isCalculatorVisible = periodValue > 0 && planValue > 0 && pointsTotal > 0;
  let priceWithDiscount = 0;

  if (discount) {
    const isFixed = discount.type === 'fixed';
    const subtraction = isFixed ? discount.value : price * (discount.value / 100);
    let totalCycles = discount?.cycles === 0 ? 12 : discount?.cycles;

    if (periodValue === 1) {
      priceWithDiscount = (price - subtraction);
    } else {

      // If discount cycles is greater than 6 and payment periodicity by semester
      // We force 6 cycles
      if (periodValue === 6 && totalCycles > 6) {
        totalCycles = 6;
      }

      priceWithDiscount = (price - (isFixed ? (subtraction * totalCycles) : subtraction));
    }
  }

  const localeOptions = { style: 'currency', currency: t('global:currency') };
  const priceFormatted = price.toLocaleString(i18n.language, localeOptions);
  const discountPriceFormatted = priceWithDiscount.toLocaleString(i18n.language, localeOptions);
  return (
    <div className={'cost-calculator ' + (isCalculatorVisible ? `cost-calculator--visible` : '')}>
      {
        (() => {
          const totalCycles = discount?.cycles;
          if (discount?.allowedPlans?.length > 0 && !discount.allowedPlans.includes(plan?.id)) {
            return <>
              <Trans t={t} i18nKey='error' values={{ coupon: coupon }} />
              <br />
              <br />
              <Trans t={t} i18nKey='default' values={{ price: priceFormatted }} />
            </>;
          }

          if (totalCycles === 0 && priceWithDiscount >= 0) {
            const key = priceWithDiscount === 0 ? 'full' : 'default';
            return <Trans t={t} i18nKey={key} values={{ price: discountPriceFormatted }} />;
          }

          if (totalCycles && priceWithDiscount >= 0) {
            const key = priceWithDiscount === 0 ? 'full' : 'before';
            return <>
              <Trans t={t} i18nKey={`discount.${key}`} values={{ price: discountPriceFormatted }} />
              <Trans t={t} i18nKey={`discount.monthsEqual${periodValue}`} values={{ cycles: totalCycles, count: totalCycles }} />
              <br />
              <br />
              <Trans t={t} i18nKey='discount.after' values={{ price: priceFormatted }} />
            </>;
          } else {
            return <Trans t={t} i18nKey='default' values={{ price: priceFormatted }} />
          }
        })()
      }
      <Trans t={t} i18nKey={`interval.${periodValue}`} />
    </div>
  );
}
CostCalculator.propTypes = {
  plan: PropTypes.object,
  points: PropTypes.string,
  period: PropTypes.object,
  product: PropTypes.object,
  discount: PropTypes.object,
  coupon: PropTypes.string,
};
export default CostCalculator;